import { useScrollVisible } from "./useScrollVisible";

const GOALS = [
  "Umgang mit belastenden Situationen, Konflikten, Emotionen und Stress",
  "Steigerung von Selbstbewusstsein",
  "Lösen von Verspannungen",
  "Lindern von Schmerzen",
  "Mehr Energie und Wohlbefinden",
  "Verlust von Geschmack und Geruch rückgängig machen",
  "Ängste bearbeiten (Prüfungsangst, Höhenangst, Flugangst …)",
  "Reduzierung von Lernschwierigkeiten",
  "Begleitung bei Therapien und der Einnahme von Medikamenten",
];

const STEPS = [
  ["01", "Zielsatz entwickeln", "Gemeinsam formulieren wir Deinen persönlichen Zielsatz."],
  ["02", "Methode finden", "Mittels Muskeltest finden wir die passende Balancetechnik heraus."],
  ["03", "Ziel stärken", "Mit der passenden Technik stärken wir Dein Ziel."],
];

export function Approach() {
  const { ref, visible } = useScrollVisible(0.1);

  return (
    <section id="ablauf" className="relative py-24 md:py-32 bg-sand-100">
      <div ref={ref} className="max-w-6xl mx-auto px-5 lg:px-10">
        <div
          className={`max-w-2xl mb-16 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-sage-700" />
            <span className="text-sage-700 text-[11px] tracking-[0.35em] uppercase font-medium">
              Ablauf &amp; Ziele
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-stone-900 leading-[1.08] tracking-tight font-semibold mb-6">
            Dein Ziel im Mittelpunkt.
          </h2>
          <p className="text-stone-700 leading-relaxed font-light text-base">
            Gerne unterstütze ich Dich in allen Lebenslagen. In einer kinesiologischen
            Behandlung widmen wir uns einem individuellen <span className="text-stone-900 font-medium">Ziel</span> von
            Dir – jedes persönliche Ziel ist grundsätzlich möglich.
          </p>
        </div>

        <div className="grid md:grid-cols-[1.25fr_1fr] gap-12 lg:gap-16">
          {/* Mögliche Ziele */}
          <div
            className={`transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <p className="text-[10px] text-sage-700 tracking-[0.3em] uppercase font-medium mb-6">
              Mögliche Ziele
            </p>
            <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
              {GOALS.map((g, i) => (
                <li key={i} className="flex gap-3 text-stone-700 text-sm leading-relaxed font-light">
                  <svg
                    className="mt-1 shrink-0 text-sage-600"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  <span>{g}</span>
                </li>
              ))}
            </ul>
            <p className="mt-8 text-stone-700/80 text-sm leading-relaxed font-light max-w-lg">
              Deinen passenden Zielsatz entwickeln wir gemeinsam. Anschließend stehen
              verschiedene Balancetechniken zur Verfügung – über den sanften Muskeltest
              finden wir die beste Methode und stärken damit Dein Ziel.
            </p>
          </div>

          {/* Ablauf & Preis */}
          <div
            className={`transition-all duration-700 delay-150 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="bg-sand-50 rounded-[2rem] p-8 md:p-9 border border-stone-800/8">
              <p className="text-[10px] text-sage-700 tracking-[0.3em] uppercase font-medium mb-7">
                So läuft eine Sitzung ab
              </p>
              <ol className="space-y-6">
                {STEPS.map(([num, title, desc]) => (
                  <li key={num} className="flex gap-4">
                    <span className="font-display text-sm text-terra-500 font-medium tracking-wider mt-0.5">
                      {num}
                    </span>
                    <div>
                      <p className="text-stone-900 font-medium text-sm mb-1">{title}</p>
                      <p className="text-stone-700 text-sm leading-relaxed font-light">{desc}</p>
                    </div>
                  </li>
                ))}
              </ol>

              <div className="mt-8 pt-7 border-t border-stone-800/10 space-y-3">
                <div className="flex justify-between items-baseline">
                  <span className="text-stone-700 text-sm font-light">Dauer</span>
                  <span className="text-stone-900 font-medium text-sm">ca. 1 – 1,5 Stunden</span>
                </div>
                <div className="flex justify-between items-baseline">
                  <span className="text-stone-700 text-sm font-light">Kinesiologische Begleitung</span>
                  <span className="font-display text-2xl text-sage-700 font-semibold">70 € / Std.</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p
          className={`mt-12 text-xs text-stone-700/60 font-light leading-relaxed max-w-2xl transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
          }`}
        >
          Eine kinesiologische Behandlung ersetzt keine medizinische oder
          psychotherapeutische Behandlung. Sie kann aber ergänzend und unterstützend
          ihren Platz einnehmen.
        </p>
      </div>
    </section>
  );
}
